"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EmojiMart = _interopRequireDefault(require("./EmojiMart.style"));

var _default = theme => {
  const EmojiMartTheme = (0, _EmojiMart.default)(theme);
  return Object.assign({}, EmojiMartTheme, {
    emoji: {
      display: 'inline-block',
      position: 'relative',
      cursor: 'pointer',
      '&.hidden': {
        display: 'none'
      },
      '&.disabled': {
        opacity: theme.disabledOpacity,
        cursor: 'default'
      }
    },
    picker: {
      zIndex: 10,
      position: 'absolute'
    }
  });
};

exports.default = _default;